import { render, staticRenderFns } from "./GameFilesControl.vue?vue&type=template&id=0ef318ec&"
import script from "./GameFilesControl.vue?vue&type=script&lang=js&"
export * from "./GameFilesControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports